export const NO_DATA = 'н/д';

export const PLANNED_ROUTE = 'planned';

export const FACT_ROUTE = 'fact';
